import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "@/utils/axiosInstance";

const DashboardCardsCommissionPartners = () => {
  const navigate = useNavigate();

  const [commission, setCommission] = useState<any>(null);

  const getMyCommission = async () => {
      try {
      const response = await axiosInstance(`/referral-agents/my-commission`);

      setCommission(response.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    let isActive = true;

    const poll = async () => {
      await getMyCommission();
      if (isActive) {
        setTimeout(poll, 5000);
      }
    };

    poll();
    return () => {
      isActive = false;
    };
  }, []);

  return (
    <div className="*:data-[slot=card]:shadow-xs @xl/main:grid-cols-2 @5xl/main:grid-cols-4 grid grid-cols-1 gap-4 px-4 *:data-[slot=card]:bg-gradient-to-t *:data-[slot=card]:from-primary/5 *:data-[slot=card]:to-card dark:*:data-[slot=card]:bg-card lg:px-6">
      <Card
        className="@container/card cursor-pointer hover:bg-muted"
        onClick={() => navigate("/taxi-orders")}
      >
        <CardHeader className="relative">
          <CardDescription>This Month</CardDescription>
          <CardTitle className="@[250px]/card:text-3xl text-2xl font-semibold tabular-nums">
            €{commission ? commission.totalFare : 0}
          </CardTitle>
          
        </CardHeader>
      </Card>
      <Card
        className="@container/card cursor-pointer hover:bg-muted"
        onClick={() => navigate("/taxi-orders")}
      >
        <CardHeader className="relative">
          <CardDescription>Your commision</CardDescription>
          <CardTitle className="@[250px]/card:text-3xl text-2xl font-semibold tabular-nums">
            €{commission ? commission.commissionAmount : 0}
          </CardTitle>
          
        </CardHeader>
      </Card>
      <Card
        className="@container/card cursor-pointer hover:bg-muted"
        onClick={() => navigate("/orders")}
      >
        <CardHeader className="relative">
          <CardDescription>Completed Orders</CardDescription>
          <CardTitle className="@[250px]/card:text-3xl text-2xl font-semibold tabular-nums">
            {commission ? commission.completedOrders : 0}
          </CardTitle>
          
        </CardHeader>
      </Card>
      <Card
        className="@container/card cursor-pointer hover:bg-muted"
        onClick={() => navigate("/orders")}
      >
        <CardHeader className="relative">
          <CardDescription>Total Orders</CardDescription>
          <CardTitle className="@[250px]/card:text-3xl text-2xl font-semibold tabular-nums">
            {commission ? commission.orders : 0}
          </CardTitle>
          
        </CardHeader>
      </Card>
      {/* <Card
        className="@container/card cursor-pointer hover:bg-muted"
        onClick={() => navigate("/tours")}
      >
        <CardHeader className="relative">
          <CardDescription>Tours</CardDescription>
          <CardTitle className="@[250px]/card:text-3xl text-2xl font-semibold tabular-nums">
            8
          </CardTitle>
          
        </CardHeader>
      </Card>
      <Card
        className="@container/card cursor-pointer hover:bg-muted"
        onClick={() => navigate("/transfers")}
      >
        <CardHeader className="relative">
          <CardDescription>Transfers</CardDescription>
          <CardTitle className="@[250px]/card:text-3xl text-2xl font-semibold tabular-nums">
            3
          </CardTitle>
          
        </CardHeader>
      </Card> */}
    </div>
  );
};

export default DashboardCardsCommissionPartners;
